import { PrivateOfficeContractsUpdate } from "@/pages/private-room/contracts-update";
import { usePoContractsUpdateFlow } from "../../context/use-po-contracts-update-flow/use-po-contracts-update-flow";
import { useEffect } from "react";
import {
  DefaultPoContractsUpdateFlowStep,
  UpsellPoContractsUpdateFlowStep,
} from "../../context/use-po-contracts-update-flow/use-po-contracts-update-flow.types";
import { PoContractsUpsell } from "../po-contracts-upsell/po-contracts-upsell";
import { PoContractsUpdateSummary } from "../po-contracts-update-summary/po-contracts-update-summary";
import { PoContractsUpdateLoading } from "../po-contracts-update-loading/po-contracts-update-loading";
import { PoContractsUpdateResult } from "../po-contracts-update-result/po-contracts-update-result";

const StepComponents = {
  [DefaultPoContractsUpdateFlowStep.UPDATE]: PrivateOfficeContractsUpdate,
  [DefaultPoContractsUpdateFlowStep.SUMMARY]: PoContractsUpdateSummary,
  [DefaultPoContractsUpdateFlowStep.LOADING]: PoContractsUpdateLoading,
  [DefaultPoContractsUpdateFlowStep.RESULT]: PoContractsUpdateResult,

  [UpsellPoContractsUpdateFlowStep.UPDATE]: PrivateOfficeContractsUpdate,
  [UpsellPoContractsUpdateFlowStep.UPSELL]: PoContractsUpsell,
  [UpsellPoContractsUpdateFlowStep.SUMMARY]: PoContractsUpdateSummary,
  [UpsellPoContractsUpdateFlowStep.LOADING]: PoContractsUpdateLoading,
  [UpsellPoContractsUpdateFlowStep.RESULT]: PoContractsUpdateResult,
} as const;

export const PoContractsUpdateFlow = () => {
  const { currentStep, setCurrentStep } = usePoContractsUpdateFlow();

  useEffect(() => {
    setCurrentStep(DefaultPoContractsUpdateFlowStep.UPDATE);
  }, []);

  const Component = StepComponents[currentStep as keyof typeof StepComponents];

  if (!Component) {
    return <PrivateOfficeContractsUpdate />;
  }

  return <Component />;
};
